import { render } from "./museumCourse.vue?vue&type=template&id=4fb7e576&scoped=true"
import script from "./museumCourse.vue?vue&type=script&lang=js"
export * from "./museumCourse.vue?vue&type=script&lang=js"

import "./museumCourse.vue?vue&type=style&index=0&id=4fb7e576&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb7e576"]])

export default __exports__